// services/liveCartService.ts
import { api } from '@/api/axiosClient'
import type { ICartService } from './cartService'
import type { CartItem /*, Cart */} from '@/types'
import { useConfig } from '@/composables/useConfig';
import type { AppConfig } from '@/configLoader';
import { toRaw } from 'vue';
import { idGenerator } from '@/utils/IdGenerator';


export class LiveCartService implements ICartService
{
    //private userId: number;
    private config: AppConfig

    constructor()
    {
        //this.userId = userId;
        this.config = useConfig();
    }

    async getCart(): Promise<CartItem[]>    
    {
        const items = await api.get(this.config.apiBaseUrl + `/cart/items`)
        const { data } = items
        return data
    }

    async addItem(item: CartItem): Promise<CartItem[]>
    {
        const { data } = await api.post(this.config.apiBaseUrl + `/cart/items`, item)
        return data
    }

    async removeItem(productId: string): Promise<CartItem[]>
    {
        const { data } = await api.delete(this.config.apiBaseUrl + `/cart/items/${productId}`)
        return data
    }

    async clearCart(): Promise<CartItem[]>
    {
        const { data } = await api.delete(this.config.apiBaseUrl + `/cart/items`)
        return data

    }

    async addProdItem(productId: string, qty: number): Promise<CartItem[]>
    {
        const item = {
            cartItemId: idGenerator.nextId(),
            productId: productId,
            qty: qty
        }

        const { data } = await api.post(this.config.apiBaseUrl + `/cart/items`, item)
        return data

    }

    async changeItemQuantity(item: CartItem, chgQtyBy: number): Promise<CartItem[]>
    {
        const copy = JSON.parse(JSON.stringify(toRaw(item)))
        copy.qty += chgQtyBy;
        const { data } = await api.patch(this.config.apiBaseUrl + `/cart/items`, copy)
        return data
    }
}
